import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import _ from "lodash";
export class BaseAxiosHttpClient {
  constructor() {
    this.axiosClient = axios.create();
    this.axiosClient.interceptors.request.use(
      this.updateRequestConfig.bind(this)
    ); // 初始化试，注册一次
  }
  private defaultConfig: AxiosRequestConfig = {};
  axiosClient: AxiosInstance;
  setDefaultHeader(key: string, value: string) {
    if (!this.defaultConfig.headers) {
      this.defaultConfig.headers = {};
    }
    this.defaultConfig.headers[key] = value;
    return this;
  }
  getAxiosClientInstance() {
    return this.axiosClient;
  }
  buildUrl(url: string) {
    if (this.defaultConfig.baseURL) {
      const baseUrl = this.defaultConfig.baseURL;
      if (_.startsWith(url, "/")) {
        return baseUrl + url;
      } else {
        return baseUrl + "/" + url;
      }
    }
    return url;
  }
  setDefaultConfig<T extends keyof AxiosRequestConfig>(
    key: T,
    value: AxiosRequestConfig[T]
  ) {
    this.defaultConfig[key] = value;
    this.axiosClient.defaults = this.defaultConfig;
    return this;
  }
  updateRequestConfig(config: AxiosRequestConfig) {
    // 以原始请求的config为准，原始config不包含的配置，用defaultConfig来填充；
    const finalConfig = _.merge({}, this.defaultConfig, config);
    return finalConfig;
  }
  setDefaultAuthorization(value: string) {
    this.setDefaultHeader("Authorization", `Bearer ${value}`);
    return this;
  }
  setDefaultAcceptLanguage(value: string) {
    this.setDefaultHeader("Accept-Language", value);
    return this;
  }
  setDefaultContentType(value: string) {
    this.setDefaultHeader("Content-Type", value);
    return this;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async get<T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axiosClient.get(this.buildUrl(url), config);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  delete<T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axiosClient.delete(this.buildUrl(url), config);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  head<T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axiosClient.head(this.buildUrl(url), config);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options<T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axiosClient.options(this.buildUrl(url), config);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post<T = any, R = AxiosResponse<T>>(
    url: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axiosClient.post(this.buildUrl(url), data, config);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  put<T = any, R = AxiosResponse<T>>(
    url: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axiosClient.put(this.buildUrl(url), data, config);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  patch<T = any, R = AxiosResponse<T>>(
    url: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axiosClient.patch(this.buildUrl(url), data, config);
  }
}
